'use client'
import { EmailTrackingSettings } from '@repo/ui/EmailTrackingSettings'
import { MatterHistorySettingsDefaults } from '@repo/ui/MatterHistorySettingsDefaults'
import { useState } from 'react'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import MUIStack from '@mui/material/Stack'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'

const EmailSyncConfiguration = () => {
  const { pageTitleBlockIsVisible } = useGlobalSettingsStore()
  const [selectedTab, setSelectedTab] = useState('matterHistory')

  return (
    <MUIStack
      data-testid="EmailSyncConfiguration"
      gap={6}
      sx={{
        maxWidth: 680,
        mx: 'auto',
        mt: pageTitleBlockIsVisible ? 0 : '10rem',
        backgroundColor: 'white',
        borderRadius: '6px',
        padding: '1rem 2rem 2rem'
      }}
    >
      <MUITabs value={selectedTab} onChange={(_, value) => setSelectedTab(value)}>
        <MUITab value="matterHistory" label="Matter history email settings" />
        <MUITab value="emailTracking" label="Email tracking settings" />
      </MUITabs>

      {selectedTab === 'matterHistory' && <MatterHistorySettingsDefaults />}
      {selectedTab === 'emailTracking' && <EmailTrackingSettings />}
    </MUIStack>
  )
}

export default EmailSyncConfiguration
